import type { ComponentPropsWithoutRef, Ref } from "react";
import { forwardRef } from "react";

const LOGO_VARIANT = {
  blue: "#1B457E",
  white: "#ffffff",
};

export const RmorLogo = forwardRef(
  (props: ComponentPropsWithoutRef<"div"> & { variant: keyof typeof LOGO_VARIANT }, ref: Ref<HTMLDivElement>) => {
    return (
      <div ref={ref} {...props}>
        <svg width="38" height="8" viewBox="0 0 38 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M-0.0175781 0.0205078V1.79363V7.99975H1.76016V1.79363H6.20463V0.0205078H-0.0175781Z"
            fill={LOGO_VARIANT[props.variant]}
          />
          <path d="M31.9824 0.0205078V1.79363V7.99975H33.7602V1.79363H37.3158V0.0205078H31.9824Z" fill={LOGO_VARIANT[props.variant]} />
          <path
            d="M11 0V7.97925H12.7777V1.77312H15.4444V7.97925H17.2222V1.77312H19.8889V7.97925H21.6666V0H11Z"
            fill={LOGO_VARIANT[props.variant]}
          />
          <path
            d="M6.20427 4.45337C5.22245 4.45337 4.42645 5.24724 4.42645 6.22657C4.42645 7.20584 5.22245 7.99969 6.20427 7.99969C7.18609 7.99969 7.98207 7.20584 7.98207 6.22657C7.98207 5.24724 7.18609 4.45337 6.20427 4.45337Z"
            fill={props.variant === "white" ? "#D69B2D" : LOGO_VARIANT[props.variant]}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.2036 7.99974H26.2065C28.4115 7.99895 30.205 6.20953 30.205 4.01009C30.205 1.81025 28.4107 0.0205078 26.2051 0.0205078C23.9994 0.0205078 22.2051 1.81025 22.2051 4.01009C22.2051 6.20953 23.9986 7.99895 26.2036 7.99974ZM26.173 1.79393C26.1746 1.79393 26.1761 1.79393 26.1777 1.79393C27.3992 1.79393 28.3895 2.78161 28.3895 3.99999C28.3895 5.21836 27.3992 6.20605 26.1777 6.20605C25.6543 6.20605 25.1735 6.02478 24.7947 5.72175C24.2894 5.31745 23.9659 4.6964 23.9659 3.99999C23.9659 2.78315 24.9536 1.79642 26.173 1.79393Z"
            fill={LOGO_VARIANT[props.variant]}
          />
        </svg>
      </div>
    );
  }
);
